module.exports = __webpack_public_path__ + "img/11.2fc661ee.png";